import { render, staticRenderFns } from "./OpzioniOrdine.vue?vue&type=template&id=079f35ce"
import script from "./OpzioniOrdine.vue?vue&type=script&lang=ts"
export * from "./OpzioniOrdine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079f35ce')) {
      api.createRecord('079f35ce', component.options)
    } else {
      api.reload('079f35ce', component.options)
    }
    module.hot.accept("./OpzioniOrdine.vue?vue&type=template&id=079f35ce", function () {
      api.rerender('079f35ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniOrdine.vue"
export default component.exports